/**
 * Centralized logging utility
 * Debug logs only appear in development mode
 */

export const logger = {
  /**
   * Debug logging - only outputs in development mode
   */
  debug: (...args: any[]): void => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },

  /**
   * Error logging - always outputs
   */
  error: (message: string, error?: Error): void => {
    console.error(`[ERROR] ${message}`, error);
  },

  /**
   * Warning logging - always outputs
   */
  warn: (message: string): void => {
    console.warn(`[WARN] ${message}`);
  },

  /**
   * Info logging - only in development
   */
  info: (...args: any[]): void => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
  }
};
